interface EmptyStateProps {
  title: string;
  body?: string;
}

export function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 py-16 px-6 text-center">
      <p className="text-base font-medium text-gray-700">{title}</p>
      {body && <p className="mt-2 max-w-md text-sm text-gray-500">{body}</p>}
    </div>
  );
}
